import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, X, CreditCard } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function GracePeriodBanner({ daysLeft, onDismiss }) {
  if (daysLeft === null || daysLeft === undefined) return null;

  const urgencyClass = daysLeft <= 2 
    ? 'bg-red-600' 
    : daysLeft <= 4 
      ? 'bg-amber-500' 
      : 'bg-amber-400';

  return (
    <div className={`${urgencyClass} text-white px-4 py-3 relative`} data-testid="grace-period-banner">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 flex-shrink-0" />
          <div className="text-sm">
            <span className="font-semibold">Payment Failed:</span>
            {' '}
            {daysLeft === 0 ? (
              <span>Your Pro subscription will be downgraded today. Update your payment now to keep your benefits.</span>
            ) : daysLeft === 1 ? (
              <span>You have <strong>1 day</strong> to update your payment before losing Pro benefits.</span>
            ) : (
              <span>You have <strong>{daysLeft} days</strong> to update your payment before losing Pro benefits.</span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/pricing">
            <Button 
              size="sm" 
              className="bg-white text-slate-800 hover:bg-slate-100 font-semibold"
              data-testid="update-payment-btn"
            >
              <CreditCard className="w-4 h-4 mr-1" />
              Update Payment
            </Button>
          </Link>
          {onDismiss && (
            <button 
              onClick={onDismiss}
              className="p-1 hover:bg-white/20 rounded transition-colors"
              aria-label="Dismiss"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
